import { GET_CUSTIMIZED_TABLE_DATA, GET_CUSTIMIZED_TABLE_DATA_FOR_OVERVIEW } from "../constants";
import { ApiCall } from "../../utils";

export const getCustomizedTableColumnsData =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/table_layout/by/${request.type}`, token);
      if(request.type === "dashboard") {
        dispatch({ type: GET_CUSTIMIZED_TABLE_DATA_FOR_OVERVIEW, payload: result.data });
      } else {
        dispatch({ type: GET_CUSTIMIZED_TABLE_DATA, payload: result.data });
      }
    } catch (error) {
      console.log(error);
    }
  };

export const addOrEditCustomizedTableColumns =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post('/table_layout/', request.payload, token);
    } catch (error) {
      console.log(error);
    }
  };
